import React from 'react';
import RldToolLanding from '../components/RldTool/RldToolLanding';

const RldTool = () => {
  return (
    <div className="rldTool--container">
      <RldToolLanding>
        <p>RLD Tool</p>
      </RldToolLanding>
    </div>
  );
};

export default RldTool;
